<template>
    <div class="company-intro">
        <!-- 上部分 -->
        <div class="intro-top">
            <div class="into-wraper">
                <div class="intro-content">
                    <h2>华软是谁？</h2>
                    <h3>华软科技股份有限公司，成立于2014年，是目前唯一的具备陆、海、空全空间无人系统与装备本体、全国产化人工智能机载大脑、综合主（运）控小脑全栈无人自主具身智能及无人异构集群协同群体智能技术和产品设计、研究与制造能力的国家高新技术企业。</h3>
                    <p>华软股份以异构协同无人化系统及装备为核心平台，具身智能、群体智能垂直行业应用为核心技术，全国产化智能大脑（服务器）与人工智能一体化平台为两翼，全面实现陆、海、空、天群体智能一体化装备在复杂全空间无人化体系场景应用。
                  华软股份的系列产品主要在电力、部队、低空经济、应急消防、新能源、森林、水利、公共安全等行业有广泛应用。
                    尤其在电力行业，华软股份的“无人化、集群化、智能化”系列产品及应用案例创造了多个行业首次，填补了国内外多项无人化巡视与作业应用场景的空白。
                    </p>
                </div>
                <div class="intro-image">
                    <img src="@/assets/home/company.png" class="companyImg" />
                </div>
            </div>

        </div>
        <!-- 下部分 -->
        <div class="intro-bottom">
            <div class="intro-bottom-wraper">
                <div class="intro-left">
                    <h2>企业文化及成果</h2>
                    <p>华软股份通过不断的自我完善和突破，深度贴近客户需求，促进无人化系统与装备应用技术更好的解决行业痛点问题，服务于市场，服务于社会。</p>
                    <ul>
                        <li v-for="(item, index) in achievements" :key="index">
                            <span class="name">{{ item.name }}</span>
                            <span class="number">
                                {{ item.number }}
                                <template v-if="item.name === '运行时长'">
                                    <sup class="sup-gap">万</sup><sup>+</sup>
                                </template>
                                <template v-else>
                                    <sup>+</sup>
                                </template>
                            </span>
                        </li>
                    </ul>
                </div>
                <div class="intro-right">
                    <div class="info-box" style="margin-left: 35%;">
                        <h3 class="info-title">企业使命</h3>
                        <p class="info-text">智能科技，变革未来</p>
                    </div>
                    <div class="info-row">
                        <div class="info-card left-card">
                            <h4 class="card-title">企业愿景</h4>
                            <p class="card-text">
                                <span style="opacity: 0.8;">不断提高智能无人装备</span>
                                <span class="highlight-text"
                                    style="opacity: 1 !important;font-weight: bold;">“无人化、集群化、智能化”</span>
                                <span style="opacity: 0.8;">行业应用领域的创新能力，打造成为全球</span>
                                <span class="opacity-1" style="font-weight: bold;">全空间无人系统与装备应用</span>
                                <span style="opacity: 0.8;">的顶尖产品制造商和整体方案服务商，致力于成为行业领跑者。</span>

                            </p>
                        </div>
                        <div class="info-card right-card">
                            <h4 class="card-title" style="color: #0F6BF6;">企业价值观</h4>
                            <p class="card-text22">严谨、执着、创新、强国</p>
                        </div>
                    </div>
                    <div class="info-box_chang">
                        <h3 class="info-title">经营理念</h3>
                        <p class="info-text">精诚合作、携手共赢&nbsp;&nbsp;&nbsp;持续创新、精益求精</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'CompanyIntro',
    data() {
        return {
            achievements: [

                { name: '专利数量', number: 500 },
                { name: '产品类型', number: 80 },
                { name: '拥有员工', number: 300 },
                { name: '运行时长', number: 50, isWan: true },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.company-intro {
    text-align: center;

    .intro-top {

        background-image: url('../../assets/home/aboutBgMid.png');
        background-size: cover;
        background-position: center;
        padding: 80PX 0PX;

        .into-wraper {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            // align-items: center;
            justify-content: space-between;
        }

        .intro-content {
            flex: 1;
            /* 两端对齐，针对中文优化 */
            text-align: justify;
            text-justify: inter-ideograph;
            /* 保证最后一行处理在各浏览器一致 */
            -webkit-text-align-last: justify;
   
            margin-right: 40px;

            h2 {
                font-size: 1.5rem;
                margin-bottom: 24px;
                color: #1E242A;
            }

            h3 {
                font-family: PingFang SC;
                font-size: 16PX;
                font-weight: bold;
                line-height: 1.7; // 增加行距
                letter-spacing: normal;
                margin-bottom: 16PX;
                color: #1E242A;
            }

            p {
                font-family: PingFang SC;
                font-size: 16PX;
                font-weight: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #1E242A;
                margin-bottom: 12PX;
                opacity: 0.8;
                line-height: 1.5;
            }
        }

        @media (max-width: 1440PX) {
            .intro-content {
                // max-height: 310PX;
                overflow-y: auto;
            }
        }

        .intro-image {
            flex: 1;
            text-align: right;

            img {
                width: 640PX;
                height: 400PX;
                border-radius: 8PX;
            }
        }
    }

    .intro-bottom {
        margin-top: 20PX;
        background-image: url('../../assets/home/aboutBgBtm.png');

        // padding: 80PX 0PX;
        height: 680PX;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;

        .intro-bottom-wraper {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            padding-top: 80PX;
        }

        .intro-left {
            flex-basis: 450PX;
            text-align: left;
            margin-right: 40PX;

            h2 {
                font-size: 32PX;
                font-weight: bold;
                color: #1E242A;
                margin-bottom: 24PX;
            }

            p {
                font-size: 16PX;
                color: rgba(30, 36, 42, 0.8);
                margin-bottom: 32PX;
            }

            ul {
                list-style: none;
                padding: 0;

                li {
                    display: flex;
                    gap: 16PX;
                    // justify-content: space-between;
                    align-items: center;
                    margin-bottom: 32PX;
                    .name {
                        font-size: 16PX;
                        color: rgba(30, 36, 42, 0.6);
                    }

                    .number {
                        font-size: 36PX;
                        color: #0F6BF6;
                        position: relative;
                        font-weight: bold;

                        sup {
                            position: relative;
                            // top: 16PX;
                            font-size: 20PX;
                            color: #0F6BF6;
                        }

                        .sup-gap {
                            margin-right: 2PX;
                        }
                    }
                }
            }
        }

        .intro-right {
            display: flex;
            flex: 1;
            flex-direction: column;
            gap: 32PX;
            // background-image: url('../../assets/home/abtMidBg.png');
            /* 添加背景图片 */
            background-size: cover;
            background-position: center;

            .info-box {
                width: 240PX;
                height: 120PX;
                border-radius: 8PX;
                background: #FFFFFF;
                box-shadow: 4PX 4PX 12PX 0PX rgba(30, 36, 42, 0.04);
                padding: 24PX;
                text-align: left;
                margin-left: 30%;

                .info-title {
                    font-size: 16PX;
                    font-weight: bold;
                    color: #0F6BF6;
                    margin-bottom: 20PX;
                    font-family: PingFang SC;
                    font-size: 18PX;
                    font-weight: bold;
                    line-height: 26PX;
                    letter-spacing: normal;
                    color: #0F6BF6;
                }

                .info-text {
                    font-size: 16PX;
                    color: rgba(30, 36, 42, 0.8);
                }
            }

            .info-box_chang {
                width: 360PX;
                height: 120PX;
                border-radius: 8PX;
                background: #FFFFFF;
                box-shadow: 4PX 4PX 12PX 0PX rgba(30, 36, 42, 0.04);
                padding: 24PX;
                text-align: left;
                margin-left: 20%;

                .info-title {
                    font-size: 16PX;
                    font-weight: bold;
                    color: #0F6BF6;
                    margin-bottom: 20PX;
                    font-family: PingFang SC;
                    font-size: 18PX;
                    font-weight: bold;
                    line-height: 26PX;
                    letter-spacing: normal;
                    color: #0F6BF6;
                }

                .info-text {
                    font-size: 16PX;
                    color: rgba(30, 36, 42, 0.8);
                }
            }

            .info-row {
                display: flex;
                gap: 32PX;

                .info-card {

                    border-radius: 8PX;
                    padding: 24PX;
                    color: #FFFFFF;
                    box-shadow: 8PX 8PX 16PX 0PX rgba(30, 36, 42, 0.1);

                    &.left-card {
                        background: #003D7E;
                        text-align: left;
                        flex-basis: 418PX;
                        height: 180PX;
                    }

                    &.right-card {
                        background: #FFFFFF;
                        flex-basis: 260PX;
                        height: 120PX;
                        color: #1E242A;
                        box-shadow: 4PX 4PX 12PX 0PX rgba(30, 36, 42, 0.04);
                        text-align: left;
                        height: 60%;
                        margin-top: 7%;
                    }

                    .card-title {
                        font-size: 18PX;
                        font-weight: bold;
                        margin-bottom: 12PX;
                    }

                    .card-text {
                        font-size: 16PX;
                        line-height: 1.5;
                        color: #fff;
                        // opacity: 0.8;
                        text-align: justify;

                    }

                    .card-text22 {
                        opacity: 1;

                        font-family: PingFang SC;
                        font-size: 16PX;
                        font-weight: normal;
                        line-height: normal;
                        letter-spacing: 0PX;

                        color: rgba(30, 36, 42, 0.8);
                    }

                    .highlight-text {
                        color: #fff;
                        opacity: 1;
                    }
                }
            }
        }
    }


}
</style>
